<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 7/11/2021
  -->

<template>
	<div class="mb-5 genogram-main-page-root" v-bind="attrsStylesClass">
		<div v-if="genogramItem && !showEmptyGenogram">
			<slot name="empty">No Genogram Available</slot>
		</div>
		<div v-if="genogramItem && showEmptyGenogram" class="cy-editor relative">
			<CyEditorView
				class="cy-editor"
				:client-profile="clientProfile"
				:readonly="readonly"
				:genogramItem="genogramItem"
				:cy-config="cyConfig"
				:dataManagerProp="dataManager"
				:editor-config="editorConfig"
				@templateAdded="onTemplateAdded"
				@detailsVisibilityChanged="onDetailsVisibilityChanged"
				@change="change"
			/>
			<slot name="genogram-overlay"></slot>
		</div>

		<LoadingIndicator/>

	</div>
</template>

<script>

import BaseClientDetailsTab from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/BaseClientDetailsTab.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import CyEditorView
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/CyEditorView.vue";
import GenogramItem from "@shared/Genogram/GenogramItem";
import GenogramKidsTemplateDialog
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramKidsTemplateDialog.vue";
import {createDialog} from "@/utils/helpers-external";
import GenogramParentsTemplateDialog
	from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramParentsTemplateDialog.vue";
import {yesNoDialog} from "@/core/components/Dialogs/dialog";


export default {
	name: "GenogramMain",
	components: {GenogramParentsTemplateDialog, GenogramKidsTemplateDialog, CyEditorView, LoadingIndicator},
	extends: BaseClientDetailsTab,

	inheritsAttrs: false,

	props: {
		genogramItemProp: GenogramItem,
		hideSaveButton: Boolean,
		showWatermark: Boolean,
		actionListener: {Function, default: () => {}},
		readonly: Boolean,
		legendBottom: String,
		canShowEmptyGenogram: {Boolean, default: true}
	},


	data() {
		return {
			isLoaded: false,
			genogramItem: null,
			cyConfig: {},
			editorConfig: {
				isLoggedIn: this.$authManager.isLoggedIn(),
				hideSaveButton: this.hideSaveButton,
				showWatermark: this.showWatermark,
				actionListener: this.actionListenerDefault,
				lineType: 'straight'
			}
		}
	},

	created() {
		if(this.legendBottom){
			this.cyConfig.legendBottom = this.legendBottom
		}
		this.loadGenogram()
	},


	methods: {

		async actionListenerDefault({action}, params){
			let res = await this.actionListener({action}, params)

			console.log("GenogramMain.actionListenerDefault action = ", action, ", res = ", res)

			if(res !== undefined){
				return res
			}

			switch (action){

				case 'getTemplateGenerationsParams':
					return this.getTemplateGenerationsParams(params)
				case 'getTemplateParentsParams':
					return this.getTemplateParentsParams(params)
				case 'getTemplateCoupleParams':
					return this.getTemplateCoupleParams(params)
				case 'getTemplateKidsParams':
					return this.getTemplateKidsParams(params)
				case 'showMessage':
					return yesNoDialog(params)
			}
		},

		async notifyTemplateRequested(){
			await this.emitPromise("templateAdded")
		},

		async getTemplateGenerationsParams(){
			await this.notifyTemplateRequested()
			let genogramParentsTemplateDialog = createDialog(GenogramParentsTemplateDialog)
			return genogramParentsTemplateDialog()
		},
		async getTemplateParentsParams(){
			await this.notifyTemplateRequested()
			let genogramParentsTemplateDialog = createDialog(GenogramParentsTemplateDialog)
			return genogramParentsTemplateDialog()
		},

		async getTemplateCoupleParams(){
			await this.notifyTemplateRequested()
			let genogramKidsTemplateDialog = createDialog(GenogramKidsTemplateDialog)
			return genogramKidsTemplateDialog()
		},

		async getTemplateKidsParams(params){
			await this.notifyTemplateRequested()
			let {existingPartners} = params
			let genogramKidsTemplateDialog = createDialog(GenogramKidsTemplateDialog)
			return genogramKidsTemplateDialog({
				existingPartners,
				showPartnerSelect: true,
			})
		},

		async loadGenogram() {

			let res
			if (this.genogramItemProp) {
				res = this.genogramItemProp
			} else {
				res = await this.handleAsync(async () => {
					let genogramItem = await this.dataManager.getGenogramByClientId(this.clientProfile.id)
					if(!genogramItem){
						genogramItem = new GenogramItem(this.clientProfile.id)
						genogramItem.addSharedWithById([this.userProfile.id, this.clientProfile.id])
					}
					return genogramItem
				})
			}

			if (res) {
				this.genogramItem = res
			}
			console.log("this.genogramItem = ", this.genogramItem)
		},

		async change() {
			await this.handleAsyncNonBlocking(() => this.dataManager.setGenogramItem(this.genogramItem))
			// console.log("Genogram.change this.genogramItem: ", JSON.stringify(this.genogramItem))
			console.log("Genogram.change this.genogramItem: ", this.genogramItem)
			// await this.$analyticManager.trackEvent("Genogram Changed")
		},

		async onDetailsVisibilityChanged(isVisible) {
			return this.emitPromise('detailsVisibilityChanged', isVisible)
		},

		async onTemplateAdded() {
			return this.emitPromise('templateAdded')
		}
	},

	computed: {
		showEmptyGenogram() {
			let elements = {}
			if (this.genogramItem) {
				elements = (this.genogramItem.jsonData || {}).elements || {}
			}

			let isGenogramEmpty = Object.keys(elements).length === 0
			return !isGenogramEmpty || this.canShowEmptyGenogram
		}
	},
}
</script>

<style lang="scss">

</style>
<style lang="scss">
.genogram-main-page-root {
	.cy-editor {
		width: 100%;
		height: 100%;
		min-height: 300px;
		position: relative;


	}
}
</style>
